import { authApi } from "@/auth";
import { dbApi } from "@/db";
import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/About.vue"),
  },
  {
    path: "/inventario",
    name: "Inventario",
    component: () => import("../views/Inventario.vue"),
    meta: {
      permission_level: "ConsultarInventario",
    },
  },
  {
    path: "/productos",
    name: "Productos",
    component: () => import("../views/Productos.vue"),
    meta: {
      permission_level: "ConsultarInventario",
    },
  },
  {
    path: "/registroPersona",
    name: "RegistroPersona",
    component: () => import("../views/RegistroPersona.vue"),
  },
  {
    path: "/movimientos",
    name: "Movimientos",
    component: () => import("../views/Movimientos.vue"),
    meta: {
      permission_level: "ConsultarMovimientos",
    },
  },
  {
    path: "/personas",
    name: "Personas",
    component: () => import("../views/Personas.vue"),
    meta: {
      permission_level: "ConsultarPersonas",
    },
  },
  {
    path: "/registroProducto",
    name: "Registro Producto",
    component: () => import("../views/RegistroProducto.vue"),
  },
  {
    path: "/tests",
    name: "Tests",
    component: () => import("../views/Tests.vue"),
  },
  {
    path: "/usuarios",
    name: "Usuarios",
    component: () => import("../views/Usuarios.vue"),
    meta: {
      permission_level: "ConsultarPersonas",
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/registroMovimiento",
    name: "RegistroMovimiento",
    component: () => import("../views/RegistroMovimiento.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// Navigation guards
router.beforeEach(async (to, from, next) => {
  // make sure the user is authenticated
  const isAuthenticated = await authApi.authenticated();

  if (to.name !== "Login" && !isAuthenticated) {
    next("/login");
  } else {
    // Check if route requires some special permission
    const permission_level = to.meta.permission_level;
    if (permission_level) {
      const user_permissions = await dbApi.GetCurrentUserPermissions();
      if (user_permissions && user_permissions.includes(permission_level)) {
        next();
      } else {
        // User doesn't have enough permission to access this route
        next("/login");
      }
    } else {
      // Route doesn't require permissions.
      next();
    }
  }
});

export default router;
